import React from 'react';
import { connect } from 'react-redux';
import UserAvatarWithInfo from '../UserAvatar/UserAvatarWithInfo';
import UserAvatar from '../UserAvatar';
import MultipleUserPopup from '../MultipleUserPopup';
import BaseComponent from '../../baseClasses/BaseComponent';
import DataSource from '../../dao/DataSource/DataSource';
import overflowSafePopupPosition from '../../helpers/popupPositioning';

import './KeyMemberDisplay.scss';

// Matches .multi-user-popup in MultipleUserPopup.scss. It sizes to its content, so there is
// no height to test against the viewport and it is always placed below its trigger.
const MULTI_USER_POPUP_WIDTH = 256;

// Change Card to the appropriate name
export class KeyMemberDisplay extends BaseComponent {
  constructor() {
    super();
    this.state = {
      displayBuildOwnerInfo: false,
    };
  }

  handleProjectRetrieval(project) {
    this.setState({ project });
  }

  handleBuildRetrieval(build) {
    this.setState({ build });
  }

  handleSetupDataSources() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
    }
    if (this.buildDataSourc) {
      this.buildDataSource.release();
    }
    if (this.props.project) {
      if(this.props.project.id == -1){
        this.setState({ project: this.props.project });
      }
      else{
        this.projectDataSource = new DataSource('Project', this.props.project.id, { project: { project_contacts: { user: {} }, project_manager: { additionalFields: ['profile_image'], role: {}, companies: {} } } },
          this.handleProjectRetrieval);
        this.projectDataSource.get();
      }
    }
    if (this.props.build) {
      this.buildDataSource = new DataSource('Build', this.props.build.id, { build: { build_owners: { additionalFields: ['profile_image'], role: {}, companies: {} } } },
        this.handleBuildRetrieval);
      this.buildDataSource.get();
    }
  }

  componentDidMount() {
    this.handleSetupDataSources();
  }
  
  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.project != prevProps.project && this.props.project) {
      this.handleSetupDataSources();
    }
  }

  handleInfoClose(){
    if(this.props.handleInfoClose){
      this.props.handleInfoClose();
    }
  }

  handleInfoOpen(assignment){
    if(this.props.handleInfoOpen){
      this.props.handleInfoOpen(assignment);
    }
  }

  handleCreateLocationMembers(){
    const { 
      locationUsers,
      displayedUserInfo, 
    } = this.props;
    if(locationUsers && locationUsers.length != 0){
      return locationUsers.map(locationUser => {
        if(locationUser){
          return (
            <div className='member-section' 
              key={`member-section-${locationUser.user ? locationUser.user.id : '0'}`}>
              <div className='divider' />
              <div className="key-member">
                <UserAvatarWithInfo
                  id={'location-member' + locationUser.id}
                  key={'location-member ' + locationUser.id}
                  user={locationUser.user}
                  large={true}
                  handleInfoOpen={this.handleInfoOpen}
                  handleInfoClose={this.handleInfoClose}
                  assignment={'key-member-' + locationUser.id}
                  displayed={displayedUserInfo}
                  title={locationUser.title}
                  company={locationUser.company}
                  overflowSafePopup={true}
                />
                <div className="key-member-role">{locationUser.title ? locationUser.title : 'Loc. Contact'}</div>
              </div>
            </div>
          );
        }
        else return null;
      });
    }
  }

  handleCreateProjectContacts(){
    const { 
      projectContacts,
      displayedUserInfo, 
    } = this.props;
    if(projectContacts && projectContacts.length != 0){
      return projectContacts.map(projectContact => {
        if(projectContact){
          return (
            <div className='member-section' 
              key={`member-section-${projectContact.user ? projectContact.user.id : '0'}`}>
              <div className='divider' />
              <div className="key-member">
                <UserAvatarWithInfo
                  id={'location-member' + projectContact.id}
                  key={'location-member ' + projectContact.id}
                  user={projectContact.user}
                  large={true}
                  handleInfoOpen={this.handleInfoOpen}
                  handleInfoClose={this.handleInfoClose}
                  assignment={'key-member-' + projectContact.id}
                  displayed={displayedUserInfo}
                  title={projectContact.title}
                  company={projectContact.company}
                  overflowSafePopup={true}
                />
                <div className="key-member-role">{projectContact.title ? projectContact.title : 'Loc. Contact'}</div>
              </div>
            </div>
          );
        }
        else return null;
      });
    }
  }

  handleDisplayBuildOwnerInfo() {
    // Centre on the avatar circle, not the .key-member column, which is wider than the icon.
    const column = this.buildOwnersRef;
    const circle = column && column.querySelector ? column.querySelector('.user-avatar') : null;
    this.setState({
      displayBuildOwnerInfo: !this.state.displayBuildOwnerInfo,
      buildOwnersPopupPosition: overflowSafePopupPosition(circle || column, MULTI_USER_POPUP_WIDTH, null),
    });
  }

  render() {
    const { 
      displayedUserInfo, 
    } = this.props;

    const project = this.state.project;
    const build = this.state.build;

    let accent_color = this.props.currentCompany ? this.props.currentCompany.accent_color : '#9b9b9b';
    let pmDisplay = null;
    let buildOwnerDisplay = null;
    let locationMembersDisplay = this.handleCreateLocationMembers();
    let projectContactsDisplay = this.handleCreateProjectContacts();
    if (project) {
      pmDisplay = (
        <div className='member-section'>
          <div className="key-member">
            <UserAvatarWithInfo
              id={
                'project-manager-' +
                (project.project_manager ? project.project_manager.id : '0')
              }
              key={
                'project-manager ' +
                (project.project_manager ? project.project_manager.id : 0)
              }
              user={project.project_manager}
              large={true}
              handleInfoOpen={this.handleInfoOpen}
              handleInfoClose={this.handleInfoClose}
              assignment={'project-manager'}
              displayed={displayedUserInfo}
              overflowSafePopup={true}
            />
            <div className="key-member-role">Project Manager</div>
          </div>
        </div>
      );
      if (build && build.build_owners) {

        //Assumes user object included in build owner object
        if (build.build_owners.length == 1) {
          buildOwnerDisplay = (
            <div className='member-section'>
              <div className='divider'/>
              <div className="key-member">
                <UserAvatarWithInfo
                  id={
                    'build-owner-' + build.build_owners[0].id
                  }
                  key={
                    'build-owner ' + build.build_owners[0].id
                  }
                  user={build.build_owners[0]}
                  large={true}
                  handleInfoOpen={this.handleInfoOpen}
                  handleInfoClose={this.handleInfoClose}
                  assignment={'build-owner'}
                  displayed={displayedUserInfo}
                  overflowSafePopup={true}
                />
                <div className="key-member-role">Build Owner</div>
              </div>
            </div>
          );
        } 
        else if (build.build_owners.length > 1) {
          buildOwnerDisplay = (
            <div className='member-section'>
              <div className='divider'/>
              <div className="key-member" ref={el => { this.buildOwnersRef = el; }}>
                <UserAvatar
                  handleSelected={this.handleDisplayBuildOwnerInfo}
                  large={true}
                  multiAssigned={true}
                />
                {
                  this.state.displayBuildOwnerInfo &&
                  <MultipleUserPopup
                    handleCloseClicked={this.handleDisplayBuildOwnerInfo}
                    isMobile={false}
                    title='Build Owners'
                    users={build.build_owners}
                    popupTopPosition={this.state.buildOwnersPopupPosition ? this.state.buildOwnersPopupPosition.top : null}
                    popupLeftPosition={this.state.buildOwnersPopupPosition ? this.state.buildOwnersPopupPosition.left : null}
                  />
                }
                <div className="key-member-role key-member-role__multiple-assigned">Build Owners</div>
              </div>
            </div>
          );
        }
      }
      
    }  
    
    return (
      <div className='key-member-display'>
        {!this.props.isLeftDividerHide &&
          <div className='divider' style={{ borderColor: accent_color }} />
        }
        {pmDisplay}
        {buildOwnerDisplay}
        {locationMembersDisplay}
        {projectContactsDisplay}
        <div className='divider' style={{ borderColor: accent_color }} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};
export default connect(mapStateToProps)(KeyMemberDisplay);



// WEBPACK FOOTER //
// ./src/components/KeyMemberDisplay/index.js